export var METHOD = "method";
export var SEPA_ACCOUNT_OWNER = "account_owner";
export var SEPA_IBAN = "iban";
export var SEPA_BIC = "bic";
export var SEPA_BANK = "bank";
export var STRIPE_TOKEN = "stripe_token";
